import { render, staticRenderFns } from "./PersistMotoristaTransbordoView.vue?vue&type=template&id=4d389faa&"
import script from "./PersistMotoristaTransbordoView.vue?vue&type=script&lang=ts&"
export * from "./PersistMotoristaTransbordoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports